export const subject = ['MATHS'];
export const SubjectEnum = {
    MATHS: 'Mathématiques',
};
export const SubjectEnumShort = {
    MATHS: 'Maths',
};
export const SubjectEmoji = {
    MATHS: '🧮',
};
export const SubjectIcons = {
    MATHS: '/icons/maths.svg',
};
export const subjectsOptions = subject.map((subj) => ({
    label: SubjectEnum[subj],
    value: subj,
}));
